import { formatCurrency } from "@/common/utils/formatters"
import { transformToNumber } from "@/common/utils/transformers"
import React from "react"
import CompanyFeeName from "../components/companyFeeName"
import CompanyFeeProduct from "../components/companyFeeProduct"
import { CompanyEventGroupedFee } from "../types/companyEventGroupedFee.type"

export class CompanyFeeTransformer {
  static tableTransformer() {
    return (fees?: CompanyEventGroupedFee[]) => {
      if (!fees?.length) return []
      return fees.map(fee => {
        const totalFee = transformToNumber({ value: fee.total_amount, invert: true })
        return {
          name: React.createElement(CompanyFeeName, { name: fee.fee_template_name }),
          product: React.createElement(CompanyFeeProduct, { product: fee.source_name || "--" }),
          amount: (
            <p className={totalFee > 0 ? 'text-valid' : totalFee < 0 ? 'text-danger-soft' : ''}>
              {formatCurrency(totalFee)}
            </p>
          )
        }
      })
    }
  }
}
